import { ProvidersType } from '../../configuration'

export interface ISlotViewItem {
  id?: string
  gameId: string
  description: string
  format?: string
  gameName: string
  sectionId?: string
  tab: string[]
  tabLive: string[]
  provider: string
  imageUrl: string
  routeProvider: ProvidersType
  isDefault?: boolean
  technologyId?: string | number
  gameUrl?: string
  hasDemoMode?: boolean
  hasFreeSpins?: boolean
  isLiveGame?: boolean
  additionalData?: any
  additionalIntegrationGameId?: string
  gameType?: ISlotsGameType
}

export interface ITabs {
  [key: string]: string[]
}

export type ISlotsGameType = 'casino' | 'live-casino' | 'amatic' | 'star-casino' | 'virtual' | 'free-spin'

export enum SlotsGameType {
  casino = 'casino',
  liveCasino = 'live-casino',
  amatic = 'amatic',
  starCasino = 'star-casino',
  virtual = 'virtual',
  freeSpin = 'free-spin',
}

export type ExternalGamesType = 'top' | 'new'

export interface ITopSlotsDTO {
  games: string[]
}

export interface INewGamesDTO {
  games: string[]
}
